import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AppBaseFormComponent } from '@components/forms/app-base-form.component';

import { SHARED_MODULES, SHARED_TUAIN_FORMS } from '@shared/shared-standalone';
import { environment } from '../../../../environments/environment';

const frm = {
  name: 'frontendConfig',
  states: { configQuery: 'configQuery' },
  sections: { frontendConfig: 'frontendConfig' },
  subsections: { frontendConfig: 'frontendConfig' },
  fields: { clientConfig: 'clientConfig' },
  actions: { updateConfig: 'updateConfig' },
  tables: {},
};

@Component({
  standalone: true,
  selector: 'app-frontend-config',
  imports: [...SHARED_MODULES, ...SHARED_TUAIN_FORMS],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div></div>
  `,
})
export class AppFrontendConfigComponent extends AppBaseFormComponent {
  override preStart() {
    this.name = 'frontendConfig';
  }

  override start() {
    super.start();
    const clientConfig = this.getFieldValue(frm.fields.clientConfig) ?? {};
    this._appConfig.updateConfiguration(clientConfig);
    this.applyCaptchaToggle(clientConfig);
  }

  /**
   * Honra el toggle de captcha PER-FRONTEND. El siteKey es global (lo sirve /api/public-config, pues
   * casa con el único secret del gateway), pero si este portal declara captchaEnabled:false NO debe
   * ejecutar reCAPTCHA. environment.recaptcha.enabled se lee vía getter en RecaptchaService, así que
   * este override se refleja en el flujo (login, pre-afiliación) aunque el servicio ya exista. Solo
   * se aplica si el backend envía el flag; si no viene, se conserva el valor del bundle.
   */
  private applyCaptchaToggle(clientConfig: { captchaEnabled?: boolean | string }) {
    if (clientConfig?.captchaEnabled === undefined) {
      return;
    }
    const captchaEnabled = clientConfig.captchaEnabled === true || clientConfig.captchaEnabled === 'true';
    environment.recaptcha = { ...environment.recaptcha, enabled: captchaEnabled };
  }
}
